import React from "react";
import classnames from "classnames";

import Styles from "./HomepageV2SectionCard.module.scss";

export type HomepageV2SectionCardVariant = "white" | "light" | "dark" | "footer";

interface HomepageV2SectionCardProps {
    variant: HomepageV2SectionCardVariant;
    as?: "section" | "footer";
    id?: string;
    className?: string;
    children: React.ReactNode;
}

const HomepageV2SectionCard = ({
    variant,
    as: Component = "section",
    id,
    className,
    children
}: HomepageV2SectionCardProps) => (
    <Component
        id={id}
        tabIndex={id ? -1 : undefined}
        className={classnames(Styles.card, Styles[variant], id && Styles.scrollTarget, className)}
        data-variant={variant}
    >
        {children}
    </Component>
);

export default HomepageV2SectionCard;
